import React from "react";
import Translation from "../../services/translation.service";

const ModalWrapperV2 = ({
  children, handleToggleModal, heading, closeBtn
}) => {

  return (
    <>
      <div className="storefront-modal-wrapper" onClick={handleToggleModal}>
        <div className="storefront-modal-wrapper-container storefront-modal-wrapper-full-width" onClick={(e) => e.stopPropagation()}>
          <div className="storefront-modal-wrapper-close">
            <span>{Translation.keys[heading] || "Select"}</span>
            <span onClick={handleToggleModal}>{Translation.keys[closeBtn] || "Close"}</span>
          </div>
          {children}
        </div>
      </div>
    </>
  );
};

export default ModalWrapperV2;
